// extracted by mini-css-extract-plugin
export var main = "fe2723990d666099569bc748db3d6470-css";